//api doc users
//https://developer.genesys.cloud/useragentman/users/
//api doc for authentication 
//https://developer.genesys.cloud/authorization/platform-auth/guides/oauth/
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_URL_API_V2 = `${BASE_URL}/api/v2`;
const PAGE_SIZE=process.env.REACT_APP_API_PAGE_SIZE;

const SKILL_FILTER=process.env.REACT_APP_SKILL_FILTER; 
const USER_FILTER=process.env.REACT_APP_USER_FILTER;
const QUEUE_FILTER= process.env.REACT_APP_QUEUE_FILTER;

export async function fetchMyProfile(token, signal) {

  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/users/me`,
    parseError: (json) => {
      const error = new Error("Failed to get my profile");
      return error;
    },
    method: "GET",
    token: token,
    signal: signal
  });
}

export async function fetchUsers(token, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/users?pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
      if (!USER_FILTER) return json.entities;
      return json.entities.filter(user => user && user.name.startsWith(USER_FILTER));
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the users");
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}


export async function fetchSkills(token, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/routing/skills?pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
      if (!SKILL_FILTER) return json.entities;
      return json.entities.filter(skill => skill && skill.name.startsWith(SKILL_FILTER));
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the skills");
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}

export async function fetchQueues(token, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/routing/queues?pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
      if (!QUEUE_FILTER) return json.entities;
      return json.entities.filter(queue => queue && queue.name.startsWith(QUEUE_FILTER));
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the queues");
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}

export async function fetchQueueMembers(token, queues, signal) {
  return await makeMultipleJsonRequests({
    generateUrl: queue => `${BASE_URL_API_V2}/routing/queues/${queue.id}/members?pageSize=${PAGE_SIZE}`,
    convertJson: (json, queue) => {
      return {queueId: queue.id, members: json.entities};
    },
    parseError: (json, queue) => {
      const error = new Error(`An error occurred while trying to fetch the skill levels: ${json.message}`);
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (queueMembers, json) => {
      if (!queueMembers) return json;
      if (!queueMembers.members) queueMembers.members = [];
      if (!json) return queueMembers;
      if (!json.members) return queueMembers;
      queueMembers.members = queueMembers.members.concat(json.members);
      return queueMembers
    },
    token: token,
    signal: signal
  }, queues);
}

export async function patchQueueMembers(token, queueMembersList) {
  await doPatchQueueMembers(token, queueMembersList, true);
  await doPatchQueueMembers(token, queueMembersList, false);
}

export async function doPatchQueueMembers(token, queueMembersList, isDelete) {
  return await makeMultipleJsonRequests({
    generateUrl: queueMembers => `${BASE_URL_API_V2}/routing/queues/${queueMembers.queueId}/members?delete=${isDelete}`,
    generateBody: queueMembers => {
      const workingMembers = isDelete ? queueMembers.membersToDelete : queueMembers.membersToAdd;
      if (!workingMembers) return;

      return workingMembers.map(member => { 
        return {
            id: member.id, 
          };
        });
    },
    parseError: json => {
      const error = new Error(`An error occurred while trying to add members to the queue: ${json.message}`);
      return error;
    },
    validateEntity: (queueMembers) => {
      if (!queueMembers) return false;
      const workingMembers = isDelete ? queueMembers.membersToDelete : queueMembers.membersToAdd;
      return workingMembers && workingMembers.length;
    },
    method: "POST",
    token: token
  }, queueMembersList);
}

export async function fetchSkillLevels(token, users, signal) {
  
  return await makeMultipleJsonRequests({
    generateUrl: user => `${BASE_URL_API_V2}/users/${user.id}/routingskills?pageSize=${PAGE_SIZE}`,
    convertJson: (json, user) => {
      return {userId: user.id, skillLevels: json.entities};
    },
    parseError: (json, user) => {
      const error = new Error(`An error occurred while trying to fetch the skill levels: ${json.message}`);
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      if (!list) return json;
      if (!list.skillLevels) list.skillLevels = [];
      if (!json) return list;
      if (!json.skillLevels) return list;
      list.skillLevels = list.skillLevels.concat(json.skillLevels);
      return list;
    },
    token: token,
    signal: signal
  }, users);
}

export async function patchSkillLevels(token, skillLevels) {

  return await makeMultipleJsonRequests({
    generateUrl: userLevels => `${BASE_URL_API_V2}/users/${userLevels.userId}/routingskills/bulk`,
    generateBody: userLevels => {
      return userLevels.skillLevels.map(skillLevel => { 
        return {
          id: skillLevel.id, 
          proficiency : skillLevel.proficiency
        };
        });
    },
    parseError: json => {
      const error = new Error(`An error occurred while trying to patch the skill levels: ${json.message}`);
      return error;
    },
    method: "PATCH",
    token: token
  }, skillLevels);
}

const getAuthenticationHeader = (token) => {
    return {
      Authorization: `bearer ${token}`,
      'content-type': 'application/json'
    }
}

const makeMultipleJsonRequests = async (config, entities) => {
  const requests = [];
  if (!entities) return;

  entities.forEach(entity => {
    if (config.validateEntity && !config.validateEntity(entity)) return;
    requests.push(getJsonPromise(config, entity));
  })

  try {
    const responses = await Promise.all(requests);
    //console.log(responses);
    return responses;
  } catch (error) {
    console.error(error);
    if (error.json) console.error(error.json);
    throw error;
  }
}

const makeJsonRequest = async (config, entity) => {
  try {
    const responses = await getJsonPromise(config, entity);
    //console.log(responses);
    return responses;
  } catch (error) {
    console.error(error);
    if (error.json) console.error(error.json);
    throw error;
  }
}

const getJsonPromise = async (config, entity) => {
  const method = config.method || "GET";
  const fetchConfig = {
    headers: getAuthenticationHeader(config.token),
    method: method,
  }

  let endResult = !config.mergeResult ? [] : null;

  let hasNextPage = true;
  let nextUri = null;

  while(hasNextPage) {
    if (method !== "GET" && config.generateBody) {
      fetchConfig.body = JSON.stringify(config.generateBody(entity))
    } 

    if (config.signal) {
      fetchConfig.signal = config.signal;
    }

    const url = !nextUri ? config.generateUrl(entity) : `${config.baseUrl}${nextUri}`;

    const response = await fetch (url, fetchConfig);
    //console.log("resp");
    //console.log(response);

    //avoid unnecessary json errors
    const text = await response.text();
    const hasParsedJson = text && text.length;
    let json = hasParsedJson ? JSON.parse(text) : text;

    hasNextPage = hasParsedJson && !!json.nextUri;
    nextUri = hasParsedJson && json.nextUri;

    if (!response.ok) {
        console.error(json);
        const error = config.parseError(json, entity);
        error.json = json;
        throw error;
    }

    if (config.convertJson) json = config.convertJson(json, entity);
    if (config.mergeResult) {
      endResult = config.mergeResult(endResult, json);
    } else if (!hasNextPage) {
      endResult = json;
    } else {
      throw new Error("Please add a mergeResult function to the config. Request has multiple pages.");
    }
  }

  return endResult;
}